export default {
  baseApiUrl: 'https://01.services.ogo.taxi',
  wsUrl: 'wss://02.services.ogo.taxi',
  wsApiUrl: 'https://02.services.ogo.taxi',
  googleMapsApiKey: 'AIzaSyBt9XxAHxFg-6cVke7aItRF4NDATE_wynM',
  userAddressesUrl: 'https://05.services.ogo.taxi',
  mapCenter: { lat: 47.151726, lng: 27.587914 },
  addrApiUrl: 'https://03.services.ogo.taxi',
  addrApiUrlNew: 'https://places-1.ogo.taxi'
}
